(() => {
  const STAGGER_IN = 35;
  const IN_DURATION = 520;
  const HOLD = 1800;
  const STAGGER_OUT = 18;
  const OUT_DURATION = 380;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (overlay) => {
    const input = overlay.parentElement.querySelector('.search-bar__input');
    const wordEl = overlay.querySelector('.rbx-search-ph__word');
    const words = (overlay.dataset.words || '').split(',').map((word) => word.trim()).filter(Boolean);
    if (!input || !wordEl || !words.length) return;

    let index = 0;
    let timer = null;
    let running = false;

    // Copy the input's own metrics so the overlay text starts exactly where typed text would.
    const syncMetrics = () => {
      const style = getComputedStyle(input);
      ['fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'letterSpacing'].forEach((prop) => {
        overlay.style[prop] = style[prop];
      });
      overlay.style.paddingLeft = `${parseFloat(style.paddingLeft) + parseFloat(style.borderLeftWidth)}px`;
      overlay.style.paddingRight = style.paddingRight;
    };

    const render = (word) => {
      wordEl.classList.remove('is-out');
      wordEl.textContent = '';
      const chars = [...word].map((char, i) => {
        const span = document.createElement('span');
        span.className = 'rbx-search-ph__char';
        span.style.setProperty('--i', i);
        span.textContent = char;
        return span;
      });
      const spark = document.createElement('span');
      spark.className = 'rbx-search-ph__spark';
      wordEl.style.setProperty('--n', chars.length);
      wordEl.append(...chars, spark);
      // While the search bar is hidden (mobile) nothing has layout, so estimate from the font size.
      const charWidth = parseFloat(getComputedStyle(input).fontSize) * 0.6;
      wordEl.style.setProperty('--w', `${wordEl.offsetWidth || chars.length * charWidth}px`);
      chars.forEach((span, i) => span.style.setProperty('--x', `${wordEl.offsetWidth ? span.offsetLeft : i * charWidth}px`));
    };

    const step = () => {
      const word = words[index % words.length];
      index += 1;
      render(word);
      timer = setTimeout(() => {
        wordEl.classList.add('is-out');
        timer = setTimeout(step, word.length * STAGGER_OUT + OUT_DURATION + 80);
      }, word.length * STAGGER_IN + IN_DURATION + HOLD);
    };

    const stop = () => {
      clearTimeout(timer);
      running = false;
    };

    const start = () => {
      if (running || document.hidden) return;
      running = true;
      step();
    };

    const update = () => {
      const hasValue = input.value !== '';
      overlay.classList.toggle('is-hidden', hasValue);
      if (reducedMotion.matches) return;
      if (hasValue || document.hidden) stop();
      else start();
    };

    syncMetrics();
    overlay.classList.add('is-ready');
    input.classList.add('has-rbx-ph');

    if (reducedMotion.matches) {
      wordEl.textContent = 'iPhone';
    }

    ['input', 'change', 'focus', 'blur'].forEach((type) => input.addEventListener(type, update));
    overlay.parentElement.querySelector('.search-bar__input-clear')?.addEventListener('click', () => setTimeout(update));
    document.addEventListener('visibilitychange', update);
    window.addEventListener('resize', syncMetrics, { passive: true });
    update();
  };

  document.querySelectorAll('[data-rbx-search-ph]').forEach(init);
})();
